import React from 'react';
import PropTypes from 'prop-types';

import marketplace from 'cfg/marketplace.json';
const { account: { manageAccountUrl, emailSubscriptionUrl, hideEmailSubscriptionLink } } = marketplace;

const NameEmailPassword = ({ email, name }, { testId }) => (
  <div data-test-id={testId('accountNameEmailPassword')}>
    <h3>Name, Email & Password</h3>
    <div data-test-id={testId('accountName')}>{name}</div>
    <div data-test-id={testId('accountEmail')}>{email}</div>
    <div>********</div>
    <div>
      <a href={manageAccountUrl} data-test-id={testId('manageAccountInfo')}>Manage Account Info</a>
    </div>
    { !hideEmailSubscriptionLink && (
      <div>
        <a href={emailSubscriptionUrl}data-test-id={testId('manageEmails')}>Manage Email Subscriptions</a>
      </div>
    )}
  </div>
);

NameEmailPassword.contextTypes = {
  testId: PropTypes.func
};

NameEmailPassword.propTypes = {
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};

export default NameEmailPassword;
